import { getItem as getSessionItem, setItem as setSessionItem } from '@/core/services/storage/utils/sessionStorageUtil';
import type {
  GetDataOptions,
  SaveDataOptions,
} from '../../domain/interfaces/StorageRepository';

export class SessionStorageRepository {
  saveData<T>(key: string, value: T, _options: SaveDataOptions): void {
    setSessionItem(key, value);
  }

  getData<T>(key: string, _options?: GetDataOptions): T | null {
    return getSessionItem<T>(key);
  }
}

